import axios from "axios";
export class CustomerSearchService {
  service = "customer";



  searchCustomer(queryParam) {
    const url = `${process.env.REACT_APP_BASE_URL}/${this.service}/searchcustomersbyphone`;
    return axios.get(url, { params: queryParam });

  }

  getIDLServices(customerNumber) {
    const url = `${process.env.REACT_APP_BASE_URL}/${this.service}/internationaldrivinglicenses`;
    return axios.get(url, {params: {customerNumber} });
  }
}
